/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ContactMethodMarketing/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function ContactMethodMarketing({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ContactInput/ContactMethodMarketing",
  onChange
  
}) {
  let isMedia = useIsMedia()
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let contactDetailsSelectedMarketingemailValueData = fromData.useDataValue({ viewPath,
context: 'contactDetails',
path: 'selected.marketingEmail',
})
let contactDetailsSelectedMarketingemailChangeData = fromData.useDataChange({ viewPath,
context: 'contactDetails',
path: 'selected.marketingEmail',
})
let dtCheckboxStrokeBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Checkbox.stroke.brand.selected'
        })
let dtCheckboxBackgroundcolorBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Checkbox.backgroundColor.brand.selected'
        })
let dtCheckboxBordercolorBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Checkbox.borderColor.brand.selected'
        })
let dtCheckboxBordercolorBrandHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Checkbox.borderColor.brand.hovered'
        })
let constantData = 'Receive marketing emails from {{division_name}}'
let widgetDivisionNameValueData = fromData.useDataValue({ viewPath,
context: 'widget',
path: 'division_name',
})
let widgetParentCompanyNameValueData = fromData.useDataValue({ viewPath,
context: 'widget',
path: 'parent_company_name',
})
let widgetLocationNameValueData = fromData.useDataValue({ viewPath,
context: 'widget',
path: 'location_name',
})
let aggregateData = fromHelpers.getText(constantData, widgetDivisionNameValueData, widgetParentCompanyNameValueData, widgetLocationNameValueData)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let contactDetailsSelectedMarketingsmsValueData = fromData.useDataValue({ viewPath,
context: 'contactDetails',
path: 'selected.marketingSms',
})
let contactDetailsSelectedMarketingsmsChangeData = fromData.useDataChange({ viewPath,
context: 'contactDetails',
path: 'selected.marketingSms',
})
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let constantData1 = 'Receive marketing SMS messages from {{division_name}}'
let widgetDivisionNameValueData1 = fromData.useDataValue({ viewPath,
context: 'widget',
path: 'division_name',
})
let widgetParentCompanyNameValueData1 = fromData.useDataValue({ viewPath,
context: 'widget',
path: 'parent_company_name',
})
let widgetLocationNameValueData1 = fromData.useDataValue({ viewPath,
context: 'widget',
path: 'location_name',
})
let aggregateData1 = fromHelpers.getText(constantData1, widgetDivisionNameValueData1, widgetParentCompanyNameValueData1, widgetLocationNameValueData1)
let widgetSettingsMarketingoptinValueData = fromData.useDataValue({ viewPath,
context: 'widget',
path: 'settings.marketingOptin',
})
let widgetDivisionNameValueData2 = fromData.useDataValue({ viewPath,
context: 'widget',
path: 'division_name',
})
let widgetParentCompanyNameValueData2 = fromData.useDataValue({ viewPath,
context: 'widget',
path: 'parent_company_name',
})
let widgetLocationNameValueData2 = fromData.useDataValue({ viewPath,
context: 'widget',
path: 'location_name',
})
let aggregateData2 = fromHelpers.getText(widgetSettingsMarketingoptinValueData, widgetDivisionNameValueData2, widgetParentCompanyNameValueData2, widgetLocationNameValueData2)
  return (<React.Fragment
>
<div
  data-testid="ContactMethodMarketing.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-2-ZKhbzu': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--jc-1-ZKhbzu': isMedia.mobile ? "space-evenly" : "space-between",'--mb-3-ZKhbzu': isMedia.mobile ? typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS : "0px"}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="ContactMethodMarketing.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 marginTop={dtSpaceS}
 marginRight={dtSpaceS}
 data="contactDetails.selected.marketingEmail"
 value={contactDetailsSelectedMarketingemailValueData}
 onChange={contactDetailsSelectedMarketingemailChangeData}
 strokeSelected={dtCheckboxStrokeBrandSelected}
 backgroundColorSelected={dtCheckboxBackgroundcolorBrandSelected}
 borderColorSelected={dtCheckboxBordercolorBrandSelected}
 borderColorHovered={dtCheckboxBordercolorBrandHovered}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
 alignSelf="center"
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 marginLeft={dtSpaceXs}
 data="'Receive marketing emails from {{division_name}}'"
 data="widget.division_name"
 data="widget.parent_company_name"
 data="widget.location_name"
 aggregate="helpers.js getText"
 text={aggregateData}
/>
</React.Fragment>
)}
</TysiaCheckbox>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 marginRight={dtSpaceS}
 marginTop={dtSpaceMs}
 data="contactDetails.selected.marketingSms"
 value={contactDetailsSelectedMarketingsmsValueData}
 onChange={contactDetailsSelectedMarketingsmsChangeData}
 strokeSelected={dtCheckboxStrokeBrandSelected}
 backgroundColorSelected={dtCheckboxBackgroundcolorBrandSelected}
 borderColorSelected={dtCheckboxBordercolorBrandSelected}
 borderColorHovered={dtCheckboxBordercolorBrandHovered}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
 alignSelf="center"
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 marginLeft={dtSpaceXs}
 data="'Receive marketing SMS messages from {{division_name}}'"
 data="widget.division_name"
 data="widget.parent_company_name"
 data="widget.location_name"
 aggregate="helpers.js getText"
 text={aggregateData1}
/>
</React.Fragment>
)}
</TysiaCheckbox>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceS}
 data="widget.settings.marketingOptin"
 data="widget.division_name"
 data="widget.parent_company_name"
 data="widget.location_name"
 aggregate="helpers.js getText"
 text={aggregateData2}
/>
</div>
</div>
{children}
</React.Fragment>)
}